import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

import type { PartnerUserStore } from "./types";

import { partnerUserInitialValue } from "./initialState";

export const usePartnerUserStore = create<PartnerUserStore>()(
	devtools(
		persist(
			(set) => {
				return {
					authenticatedUser: {
						partnerUser: partnerUserInitialValue,
					},
					addAuthenticatedUser: (payload) => {
						set({
							authenticatedUser: {
								partnerUser: payload,
							},
						});
					},
					resetStore: () => {
						usePartnerUserStore.persist.clearStorage();
						set({
							authenticatedUser: {
								partnerUser: partnerUserInitialValue,
							},
						});
					},
				};
			},
			{
				name: "acp-partner-user-store",
			},
		),
	),
);
